import React from "react";
import {Col, ColorPicker, Row, Space} from "antd";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  {key: "id", title: "Mã", dataIndex: "id", align: "left"},
  {key: "tenDVTBP", title: "Đơn vị tính", dataIndex: "tenDVTBP", align: "left"},
  {key: "3", title: "Mô tả", dataIndex: "moTa"},
  {key: "4", title: "Thao tác", dataIndex: "action"},
];
export {columns};
